import { Component, OnInit, HostBinding, OnDestroy, Renderer2, AfterViewInit, Inject } from '@angular/core';
import { PageService } from '../../services/page.service';
import { PageLookupService } from '../../services/page-lookup.service';
import { Page } from '../../interfaces/page';
import { NavigationEnd, ActivatedRouteSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SeoService } from "../../services/seo.service";
import { SmartLabelService } from "../../components/smart-label/smart-label.service";
import { GatemanService } from "../../services/gateman.service";
import { AppService } from "../../services/app.service";
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostBinding('class') class = 'ion-page';
  @HostBinding('style.padding-bottom') get offsetBottom() {
    // console.log('offsetTop');
    // console.log(this.pageService);
    const defaultFooterHeight = 56;
    let height = 0;
    if (this.pageService.pageMode == 'smartlabel') {
      height += defaultFooterHeight;
    }
    if (this.pageService.diLayout.isFooterEnabled) {

      let footerHeight = 0;

      if (this.pageService.diLayout.hasOwnProperty('footer')) {
        if (this.pageService.diLayout.footer.hasOwnProperty('footerHeight')) {

          footerHeight = Number.parseInt(this.pageService.diLayout.footer.footerHeight || defaultFooterHeight, 10);


        } else {

          footerHeight = defaultFooterHeight;
        }
      }

      height += footerHeight;
    }



    return `${height}px`;
  }
  @HostBinding('style.padding-top') get offsetTop() {
    const basePadding = 0;
    let total = basePadding;
    if (this.pageService.diLayout.isHeaderEnabled) {
      const defaultHeaderHeight = 56;
      const headerheight = Number.parseInt(this.pageService.diLayout.header.headerHeight || defaultHeaderHeight, 10);
      total += headerheight;
    }
    const searchbox = this.activatedRoute.snapshot.queryParams.searchbox;
    if (searchbox) {
      const searchboxHeight = 60;
      total += searchboxHeight;
    }
    return `${total}px`;
  }
  contentControls = [];
  routerEndSubscription: Subscription;
  diLayoutSubscription: Subscription;
  smartlabelLinkListener;
  isSmartlabelMode: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public pageService: PageService,
    private pageLookupService: PageLookupService,
    private seoService: SeoService,
    private smartlabelService: SmartLabelService,
    private renderer: Renderer2,
    private gatemanService: GatemanService,
    private appService: AppService, private titleService: Title,
    @Inject(DOCUMENT) private document: HTMLDocument) {
  }

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {
    //console.log('Main init');
    // Initial page lookup
    // this.loadPage();
    // Do pagelookup after everytime route change
    this.routerEndSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //console.log(this.router);
        // console.log(event);
        // console.log(this.router.getCurrentNavigation());
        const navigation = this.router.getCurrentNavigation();
        const extras = navigation.hasOwnProperty('extras') && navigation.extras ? navigation.extras : {};
        const state = extras.hasOwnProperty('state') && extras.state ? extras.state : {};
        //console.log({ state })
        if (state.hasOwnProperty('skipLoadPage') && state.skipLoadPage) {
          //console.log('Not Loaded');
          return;
        } else {
          //console.log('Call Load Page');
          this.loadPage();
        }
      }
    });
    // Whenever diLayout variable changes, trigger page lookup
    this.diLayoutSubscription = this.pageService.diLayout$.subscribe((diLayout) => {
      this.loadPage();
    });

    // Set variables on change
    this.smartlabelService.smartLabelEvents$.subscribe(event => {
      if (event.type === 'smartlabel-selector' && event.payload && event.payload.type === 'product-variant-selector') {
        const index = event.payload.value;
        this.pageService.variantDisplayIndex = index;
        this.loadPage();
        // this.router.navigate([], {replaceUrl: true, queryParams : {variantDisplayIndex: index}, queryParamsHandling: 'merge'});
      }
    });
  }

  /**
   * Loads Page based on the current activated route, set it as current Page and Renders it.
   * @return [nothing]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
   */
  loadPage() {
    //console.log('Load');

    if (!this.pageService.renderPage) {
      if (this.pageService.redirectionURL) {
        if (document.location.href !== this.pageService.redirectionURL) {
          // document.location.href = this.pageService.redirectionURL;
          return;
        }
      }
    }

    const sandbox = this.activatedRoute.snapshot.queryParams.sandbox;


    if (sandbox) {
      this.appService.isSandboxMode.next(true);
      this.appService.listTranslated = false;
    }

    //Updated by Neil if the user goes directly to a smartlabel detail pages the data is unavailable
    //console.log('Load Page MC DIData', this.pageService.diData);
    if (this.pageService.diData) {

      //console.log('pageService.diData', this.pageService.diData);
      //@NOTE: CODE FOR HANDLING VARIANTS
      this.smartlabelService.entityInformation = this.pageService.diData;
      if (this.pageService.diData.hasOwnProperty('_productId')) {

        this.smartlabelService.isProductEntity = true;

        if (this.pageService.diData.hasOwnProperty('productvariant') && this.pageService.diData.productvariant.length > 0) {
          const variantIndex = this.pageService.variantDisplayIndex;
          // load variant from variant index
          const variant = this.pageService.diData.productvariant[variantIndex];

          this.smartlabelService.smartLabelData = variant;
          this.pageService.smartLabelData = variant;

          if (variant.hasOwnProperty('_listInformation')) {
            this.pageService.listItemMap = this.appService.getListItemMap(variant._listInformation);
          }
        } else {
          //@note variables that need to be set/unset on selecting a variant
          this.smartlabelService.smartLabelData = {};
          this.pageService.smartLabelData = {};
          this.pageService.listItemMap = {};
          this.smartlabelService.isProductEntity = false;
        }

      } else {
        this.smartlabelService.smartLabelData = this.pageService.diData;
        this.pageService.smartLabelData = this.pageService.diData;
        this.smartlabelService.isProductEntity = false;
      }




      //this.appService.listCodeTranslate(this.pageService.diData);
    }


    this.pageService.listIndex = this.activatedRoute.snapshot.queryParams.listIndex;
    const page = this.pageLookupService.resolvePage(this.activatedRoute.snapshot, this.router.routerState.snapshot);
    // console.log({ page })

    if (Object.keys(page).length > 0) {
      this.pageService.setCurrentPage(page);

      //set page className
      if (this.pageService.getPageMode(page) === 'smartlabel') {
        this.isSmartlabelMode = true;
      } else {
        this.isSmartlabelMode = false;
      }

      this.renderPage(page);
    } else {
      if (!sandbox) {
        //DEBUG
        this.router.navigate(['error', 404]);
      }
    }
    this.updateTitleAndIcon();
  }

  /**
   * [renderPage description]
   * @param  page [Recieves page and renders and it and changes contentControls]
   * @return      [Nothing]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
  */
  renderPage(page: Page) {
    //console.log('render page')
    this.pageService.render(page);
    this.contentControls = this.pageService.contentControls;
  }

  ngOnDestroy() {
    // console.log('Main - OnDestroy');
    if (this.routerEndSubscription) {
      this.routerEndSubscription.unsubscribe();
    }
    if (this.diLayoutSubscription) {
      this.diLayoutSubscription.unsubscribe();
    }
    if (this.smartlabelLinkListener) {
      this.smartlabelLinkListener();
    }

  }

  /**
   * Bound renderer listener to listen to <a> clicks to trigger smartlabel alert popup
   * @author NeilC
   * @return []
   */
  ngAfterViewInit() {
    // NOTE: Need to optimize to listen to only a clicks instead of all document clicks
    this.smartlabelLinkListener = this.renderer.listen('document', 'click', ($event: MouseEvent) => {
      const el = $event.srcElement as HTMLInputElement;
      //console.log($event);
      let gated: any = true;

      if (el.hasAttribute('gated')) {
        gated = el.getAttribute('gated');
      }

      const href = el.getAttribute('href');
      const target = el.getAttribute('target');
      if (href) {
        $event.preventDefault();
        $event.stopPropagation();
        this.gatemanService.routeHub(href, { target: target, gated: gated });
        // console.log('className',el.className);
        // let classNames = el.className.split('');
        // console.log('classNames', classNames);
        // if(['smartlabel-link', 'page-link', 'editor-link'].includes(el.className)) {
        // }
      }
    });
  }

  /**
   * Update the respective icon and text on browser. Smartlabel text and icon if smartlabel control , Qliktag text and icon if control otherthan smartlabel
   * @author Venkatesh Pasal
   * @task QLIKTAG-3503
   */

  updateTitleAndIcon() {
    const appTitle = "Digital Interaction";
    const smartTitle = "SmartLabel™";
    if (this.isSmartlabelMode) {
      this.titleService.setTitle(smartTitle);
      this.document.getElementById('touchIcon').setAttribute('href', '../../assets/icons/smartlabel.ico');
      this.document.getElementById('favicon').setAttribute('href', '../../assets/icons/smartlabel.ico');
    } else {
      this.document.getElementById('touchIcon').setAttribute('href', '/api/__design/favicon.ico');
      this.document.getElementById('favicon').setAttribute('href', '/api/__design/favicon.ico');
      this.titleService.setTitle(appTitle);
    }
  }

  /**
   * getPaddingBottom - calculates and returns bottom padding.
   * @return - style object.
   * @author - SwapnilP
   * @task - QLIKTAG-3356
   */
  getPaddingBottom() {
    const basePadding = 0;
    let footerHeight = 0;
    if (this.pageService.diLayout.isFooterEnabled) {
      footerHeight = Number.parseInt(this.pageService.diLayout.footer.footerHeight || 60, 10);

    }
    const total = basePadding + footerHeight;




    return {
      'padding-bottom': total + 'px'
    };
  }
}
